import React, { useState } from 'react';
import './ScheduleView.css';
import { sendFeedback } from '../../utils/sendFeedback';
import { ProgressionStatus } from '../../types/olympicsListableEvent';

interface FeedbackFormProps {
  insight: string;
  eventId: number;
  progressStatus: ProgressionStatus;
  urls: string[];
  onResponse: () => void;
}

export const FeedbackForm: React.FC<FeedbackFormProps> = ({
  insight,
  eventId,
  progressStatus,
  urls,
  onResponse,
}) => {
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [selectedOption, setSelectedOption] = useState<'positive' | 'neutral' | 'negative' | null>(
    null,
  );
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  const handleFeedback = (feedbackType: 'positive' | 'neutral' | 'negative') => {
    setSelectedOption(feedbackType);
    const truncatedInsight = insight.slice(0, 4999);
    const timestamp = new Date().toISOString().slice(0, 200); // Max 200 characters
    const truncatedEventId = eventId.toString().slice(0, 4999); // Max 4999 characters

    // Truncate urls array if separated string exceeds 4999 characters
    let truncatedUrls = [...urls];
    while (truncatedUrls.length > 0 && truncatedUrls.join('XXSEPARATEYY').length > 4999) {
      truncatedUrls.pop();
    }

    sendFeedback(
      truncatedInsight,
      feedbackType,
      truncatedEventId,
      timestamp,
      progressStatus, // ProgressionStatus max length is 10 chars, always within 50 char limit
      truncatedUrls,
    );
    setFeedbackSent(true);
    onResponse(); // Notify parent that user has responded
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div className='feedback-form'>
      <div className='feedback-form-header'>
        <span className='feedback-form-title'>
          {feedbackSent ? 'Kiitos palautteesta!' : 'Mitä mieltä tiivistelmästä?'}
        </span>
        <button className='feedback-form-close' onClick={handleClose} aria-label='Sulje'>
          ×
        </button>
      </div>
      {!feedbackSent && (
        <div className='feedback-form-options'>
          <label className='feedback-form-option'>
            <input
              type='radio'
              name='feedback'
              value='positive'
              checked={selectedOption === 'positive'}
              onChange={() => handleFeedback('positive')}
            />
            <span>Hyödyllinen</span>
          </label>
          <label className='feedback-form-option'>
            <input
              type='radio'
              name='feedback'
              value='neutral'
              checked={selectedOption === 'neutral'}
              onChange={() => handleFeedback('neutral')}
            />
            <span>Neutraali</span>
          </label>
          <label className='feedback-form-option'>
            <input
              type='radio'
              name='feedback'
              value='negative'
              checked={selectedOption === 'negative'}
              onChange={() => handleFeedback('negative')}
            />
            <span>Turha</span>
          </label>
        </div>
      )}
    </div>
  );
};
